var map = {
	"./phtot1.jpg": 5214,
	"./phtot2.jpg": 4809,
	"./phtot3.jpg": 9548,
	"./phtot4.jpg": 5863,
	"./phtot5.jpg": 4698,
	"./phtot6.jpg": 2549,
	"./phtot7.jpg": 4936,
	"./phtot8.jpg": 7699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8661;